import { useEffect, useRef, useState } from 'react';

export const useVehicleHistoryPlayback = (coords, triggerId) => {
  const [coordsState, setCoordsState] = useState([]);
  const [runRec, setRunRec] = useState(false);
  const [speedRec, setSpeedRec] = useState(1);
  const [positionHistory, setPositionHistory] = useState();
  const timerIdRef = useRef(null);

  // Запуск воспроизведения
  const handleStart = () => {
    if (coordsState.length === 0 && coords?.length) {
      // Выбираем первую точку, чтобы карта перемещалась сразу куда надо
      setCoordsState([coords[0]]);
    }
    setRunRec(true);
  };

  // Остановка воспроизведения
  const handleStop = () => {
    clearInterval(timerIdRef.current);
    setRunRec(false);
  };

  useEffect(() => {
    setRunRec(false);
    setPositionHistory(undefined);
    setCoordsState([]);
  }, [triggerId]);

  // Эффект для управления интервалом воспроизведения
  useEffect(() => {
    if (!coords?.length) setCoordsState([]);

    if (runRec && coords?.length) {
      timerIdRef.current = setInterval(() => {
        setCoordsState((prevCoords) => {
          const nextIndex = prevCoords.length;
          if (nextIndex < coords.length) {
            return [...prevCoords, coords[nextIndex]];
          }
          handleStop();
          return prevCoords;
        });
      }, 1000 / speedRec);
    }

    return () => {
      clearInterval(timerIdRef.current);
    };
  }, [runRec, speedRec, coords]);

  // Эффект для управления позицией истории
  useEffect(() => {
    if (positionHistory && coords) {
      setCoordsState(coords.slice(0, positionHistory));
    }
  }, [positionHistory, coords]);

  return {
    coordsState,
    setCoordsState,
    runRec,
    setRunRec,
    speedRec,
    setSpeedRec,
    positionHistory,
    setPositionHistory,
    handleStart,
    handleStop,
  };
};

export default useVehicleHistoryPlayback;
